module.exports = __webpack_public_path__ + "img/logo.4eabad6e.png";